import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NavigationConfig } from '../utils/navigation-constants';
import { PageNotFound } from '../pages/page-not-found';
import { Home } from '../pages/home/index';
import { ProfileSetting } from '../pages/profile-setting';
import { ManageInstaller } from '../pages/manage-installer';
import { ManageWorkOrder } from '../pages/manage-work-order';
import { ManageCustomer } from '../pages/manage-customer';
import CustomerDetails from '../pages/manage-customer/view';
import EditCustomer from '../pages/manage-customer/edit';
import { ManageAdmin } from '../pages/manage-admin';
import { InstallerDetails } from '../pages/installer-details';
import NotificationViewAll from '../pages/notifications';
import ProtectedFeatureRoute from './protected-feature-route';

export const PostAuthenticatedRoutes: React.FC = () => {
    return (
        <Routes>
            {/* Dashboard/Home - example, always visible */}
            <Route path={NavigationConfig.Home} element={<Home />} />

            {/* Manage Admins - protected */}
            <Route element={<ProtectedFeatureRoute feature="manage_admins" />}>
                <Route path={NavigationConfig.ManageAdmin} element={<ManageAdmin />} />
            </Route>

            {/* Manage Customers - protected */}
            <Route element={<ProtectedFeatureRoute feature="manage_customers" />}>
                <Route path={NavigationConfig.ManageCustomer} element={<ManageCustomer />} />
                <Route path={NavigationConfig.CustomerDetails} element={<CustomerDetails />} />
                <Route path={NavigationConfig.EditCustomer} element={<EditCustomer />} />
            </Route>

            {/* Manage Installers - protected */}
            <Route element={<ProtectedFeatureRoute feature="manage_installers" />}>
                <Route path={NavigationConfig.ManageInstaller} element={<ManageInstaller />} />
                <Route path={NavigationConfig.InstallerDetails} element={<InstallerDetails />} />
            </Route>

            {/* Manage Workorders - protected */}
            <Route element={<ProtectedFeatureRoute feature="manage_workorders" />}>
                <Route path={NavigationConfig.ManageWorkOrder} element={<ManageWorkOrder />} />
            </Route>

            {/* Profile - protected */}
            <Route element={<ProtectedFeatureRoute feature="profile" />}>
                <Route path={NavigationConfig.ProfileSetting} element={<ProfileSetting />} />
            </Route>

            {/* Notifications - protected */}
            <Route element={<ProtectedFeatureRoute feature="dashboard" />}>
                <Route path="/" element={<Navigate to={NavigationConfig.Home} />} />
                <Route path={NavigationConfig.Notifications} element={<NotificationViewAll />} />
            </Route>

            {/* Default and fallback */}
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};
